import { render, staticRenderFns } from "./AgentTaskBubble.vue?vue&type=template&id=9634f68a"
import script from "./AgentTaskBubble.vue?vue&type=script&lang=js"
export * from "./AgentTaskBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports